export default "__VITE_ASSET__DW8tJM6r__"